import { render, staticRenderFns } from "./board_mainpopup_view.vue?vue&type=template&id=5414eb81&"
import script from "./board_mainpopup_view.vue?vue&type=script&lang=js&"
export * from "./board_mainpopup_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports